module.exports = __webpack_public_path__ + "static/media/Providing_digital_healthcare_through_the_GDPR-secure_telemedicine_platform.eb422ffb.webp";